import React from 'react';
import {TextInput, Button, Group, Box, Grid, Select} from '@mantine/core';
import {useForm} from '@mantine/form';
import {IUser} from "../../../api/User/User.types";
import LoaderDefault from "../../common/Loader.default/Loader.default";


interface Props {
    onSubmitQuery?: (query: any) => void,
    initialValues?: any
    user?: IUser
}

interface FormValues {
    consigneeId: string,
    aglContractId: string,
    nvoName: string,
}

function RatesFilters({onSubmitQuery, initialValues, user}: Props) {
    const form = useForm<FormValues>({
        initialValues: initialValues || {
            consigneeId: "",
            aglContractId: "",
            nvoName: ""
        }
    });

    function onSubmit(values: typeof form.values) {
        if (onSubmitQuery) {
            onSubmitQuery(values)
        }
    }

    if (!user || !user.consignees) {
        return <LoaderDefault text="Loading User..."/>
    }


    return (
        <div className='rates-filters'>
            <Box mx="auto">
                <form onSubmit={form.onSubmit(onSubmit)}>
                    <Grid>
                        <Grid.Col sm={6} lg={4}>
                            <Select
                                data={user?.consignees?.map(sh => ({value: sh.entityID, label: sh.entityName}))}
                                required
                                placeholder="Consignee Name"
                                label="Name"
                                {...form.getInputProps('consigneeId')}/>
                        </Grid.Col>
                        <Grid.Col sm={6} lg={4}>
                            <TextInput
                                label="Contract ID"
                                placeholder="Contract ID"
                                {...form.getInputProps('aglContractId')}
                            />
                        </Grid.Col>
                        <Grid.Col sm={6} lg={4}>
                            <TextInput
                                label="NVO Name"
                                placeholder="NVO Name"
                                {...form.getInputProps('nvoName')}
                            />
                        </Grid.Col>
                    </Grid>
                    <Group position="right" mt="md">
                        <Button type="submit">Submit</Button>
                    </Group>
                </form>
            </Box>
        </div>
    )
}

export default RatesFilters;